export default __webpack_public_path__ + "static/media/chart-snr-distribution-1_LS.3b3069f6.png";